import { OptionCard } from './OptionCard'
import { OptionsGrid, OtherInputContainer } from './styles/OptionCardStyles'
import { QuestionTitle, OtherInput } from './styles/SignUpFlowStyles'
import { PARTNER_PROMOTION_CHANNELS } from '../../constants/partnerSurveyOptions'

interface PartnerSurveyStepPromotionProps {
  values: string[]
  otherValue: string
  onChange: (values: string[]) => void
  onOtherChange: (value: string) => void
}

export function PartnerSurveyStepPromotion({
  values,
  otherValue,
  onChange,
  onOtherChange,
}: PartnerSurveyStepPromotionProps) {
  const handleToggle = (value: string) => {
    if (values.includes(value)) {
      onChange(values.filter((v) => v !== value))
    } else {
      onChange([...values, value])
    }
  }

  return (
    <div>
      <QuestionTitle>How do you plan to promote Bandos?</QuestionTitle>
      <OptionsGrid>
        {PARTNER_PROMOTION_CHANNELS.map((option) => (
          <div key={option.value}>
            <OptionCard
              label={option.label}
              isSelected={values.includes(option.value)}
              onClick={() => handleToggle(option.value)}
              isMultiSelect={true}
            />
            {option.value === 'other' && values.includes('other') && (
              <OtherInputContainer>
                <OtherInput
                  type="text"
                  placeholder="Please describe your promotion method"
                  value={otherValue}
                  onChange={(e) => onOtherChange(e.target.value)}
                  autoFocus
                />
              </OtherInputContainer>
            )}
          </div>
        ))}
      </OptionsGrid>
    </div>
  )
}
